import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import '@formatjs/intl-relativetimeformat/dist/locale-data/es';

const mapStateToProps = state => {
  const { active, messages } = state.locales;

  return {
    locale: active,
    messages: messages[active],
    defaultLocale: 'en',
    key: `locale-${active}`,
  };
};

export default connect(mapStateToProps)(IntlProvider);
